import React from "react";
import Header from "../../components/Header";
import { IconButton } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import { COMPONENT_ERROR_TEXT, subformInputChange } from "../../utils";
import { Card, Flex } from "antd";
import TextField from "../../components/TextField";
import DateField from "../../components/DateField";
import CheckboxAntd from "../../components/CheckboxAntd";

const Contract = ({ data, setData, error, setError, disabled, btnLoading }) => {
  return (
    <div>
      <Header text="Contracted Carriers, MGA's and Wholesalers" />

      <div className="form_container">
        <Flex gap={32} align="center" className="mb_16">
          <div className="label">List of Contracted Carriers</div>
          {/* <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.contracts.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.contracts.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.contracts.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                contracts: [
                  ...data?.contracts,
                  { key, company_name: undefined, date_appointed: undefined },
                ],
              });

              setError({
                ...error,
                contracts: [
                  ...error?.contracts,
                  { key, company_name: undefined, date_appointed: undefined },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading}
          >
            Add contract
          </button> */}
        </Flex>

        <Flex vertical gap={32}>
          {data?.contracts.map((item, index) => {
            return (
              <Card
                title={
                  <p>
                    Contract #{index + 1}{" "}
                    {Object.values(error.contracts[index]).some(
                      (value) => value === true
                    ) ? (
                      <span className="subform_error_text">
                        {COMPONENT_ERROR_TEXT}
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                }
                size="small"
                key={index}
                extra={
                  <IconButton
                    onClick={() => {
                      let filter = data?.contracts.filter(
                        (i) => item?.key !== i?.key
                      );

                      let error_filter = error?.contracts.filter(
                        (i) => item?.key !== i?.key
                      );

                      if (filter.length === 0) {
                        return;
                      }

                      setError({ ...error, contracts: error_filter });
                      setData({ ...data, contracts: filter });
                    }}
                    disabled={
                      data?.contracts.length === 1 ||
                      disabled?.stage ||
                      btnLoading
                    }
                  >
                    <DeleteIcon
                      style={{ fontSize: "1.25rem", color: "#fb7d7f" }}
                    />
                  </IconButton>
                }
              >
                <div className="form_container" style={{ padding: "0" }}>
                  <TextField
                    size="middle"
                    label="Company Name"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "contracts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="company_name"
                    value={item?.company_name}
                    required
                    error_state={error?.contracts[index]?.company_name}
                    disabled={disabled?.stage || btnLoading}
                  />{" "}
                  <DateField
                    size="middle"
                    label="Date Appointed"
                    handleChange={(date, dateString) =>
                      subformInputChange({
                        value: date,
                        name: "date_appointed",
                        object_key: "contracts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                        custom: "date",
                      })
                    }
                    name="date_appointed"
                    value={item?.date_appointed}
                    required
                    error_state={error?.contracts[index]?.date_appointed}
                    disabled={disabled?.stage || btnLoading}
                  />
                </div>
              </Card>
            );
          })}
        </Flex>
        {/* //added by Krishnaja */}
        <>
        <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.contracts.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.contracts.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.contracts.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                contracts: [
                  ...data?.contracts,
                  { key, company_name: undefined, date_appointed: undefined },
                ],
              });

              setError({
                ...error,
                contracts: [
                  ...error?.contracts,
                  { key, company_name: undefined, date_appointed: undefined },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading}
          >
            Add contract
          </button>
        </>
      </div>

      <div className="mb_16"></div>

      <div className="form_container">
        <CheckboxAntd
          label="Check this if you have no MGA"
          checked={data?.no_mga}
          onChange={(e) => {
            setData({ ...data, no_mga: e.target.checked });

            // if (e.target.checked) {
            //   let error_mga = [...error?.mga];

            //   error_mga.map((item) => {
            //     for (const key in item) {
            //       item[key] = undefined;
            //     }
            //   });

            //   setError({ ...error, mga: error_mga });
            // }
          }}
          disabled={disabled?.stage || btnLoading}
        />
      </div>

      <div className="form_container">
        <Flex gap={32} align="center" className="mb_16">
          <div className="label">List of MGA's & Wholesalers</div>
          {/* <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.mga.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.mga.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.mga.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                mga: [...data?.mga, { key, mga_name: "", annual_premium: "" }],
              });

              setError({
                ...error,
                mga: [
                  ...error?.mga,
                  { key, mga_name: undefined, annual_premium: undefined },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading || data?.no_mga === true}
          >
            Add MGA
          </button> */}
        </Flex>

        <Flex vertical gap={32}>
          {data?.mga.map((item, index) => {
            return (
              <Card
                title={
                  <p>
                    MGA #{index + 1}{" "}
                    {Object.values(error.mga[index]).some(
                      (value) => value === true
                    ) ? (
                      <span className="subform_error_text">
                        {COMPONENT_ERROR_TEXT}
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                }
                size="small"
                key={index}
                extra={
                  <IconButton
                    onClick={() => {
                      let filter = data?.mga.filter(
                        (i) => item?.key !== i?.key
                      );

                      let error_filter = error?.mga.filter(
                        (i) => item?.key !== i?.key
                      );

                      if (filter.length === 0) {
                        return;
                      }

                      setError({ ...error, mga: error_filter });

                      setData({ ...data, mga: filter });
                    }}
                    disabled={
                      data?.mga.length === 1 || disabled?.stage || btnLoading
                    }
                  >
                    <DeleteIcon
                      style={{ fontSize: "1.25rem", color: "#fb7d7f" }}
                    />
                  </IconButton>
                }
              >
                <div className="form_container" style={{ padding: "0" }}>
                  <TextField
                    size="middle"
                    label="MGA Name"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "mga",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="mga_name"
                    value={item?.mga_name}
                    error_state={error?.mga[index]?.mga_name}
                    disabled={
                      disabled?.stage || btnLoading || data?.no_mga === true
                    }
                    required={data?.no_mga === false}
                  />{" "}
                  <TextField
                    size="middle"
                    label="Annual Premium $"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: "annual_premium",
                        object_key: "mga",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                        custom: "number",
                      })
                    }
                    name="annual_premium"
                    value={item?.annual_premium}
                    error_state={error?.mga[index]?.annual_premium}
                    disabled={
                      disabled?.stage || btnLoading || data?.no_mga === true
                    }
                    required={data?.no_mga === false}
                  />
                </div>
              </Card>
            );
          })}
        </Flex>
        {/* //Added by Krishnaja */}
        <>
        <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.mga.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.mga.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.mga.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                mga: [...data?.mga, { key, mga_name: "", annual_premium: "" }],
              });

              setError({
                ...error,
                mga: [
                  ...error?.mga,
                  { key, mga_name: undefined, annual_premium: undefined },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading || data?.no_mga === true}
          >
            Add MGA
          </button>
        </>
      </div>
    </div>
  );
};

export default Contract;
